var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import classnames from 'classnames';
import { Icon } from '../Icon';
export const ActionMenuItem = React.forwardRef((_a, ref) => {
    var { cascading = false, children, className, disabled, icon: iconName, iconColor } = _a, rest = __rest(_a, ["cascading", "children", "className", "disabled", "icon", "iconColor"]);
    const newRef = React.useRef(null);
    const itemRef = ref ? ref : newRef;
    const ActionMenuItemClasses = classnames('ActionMenuItem', className, {
        'ActionMenuItem--disabled': disabled,
        'ActionMenuItem--cascading': cascading,
    });
    return (React.createElement("button", Object.assign({ className: ActionMenuItemClasses, disabled: disabled, onMouseEnter: () => { var _a; return (_a = itemRef.current) === null || _a === void 0 ? void 0 : _a.focus(); }, ref: itemRef, role: "button" }, rest),
        iconName ? (React.createElement("span", { className: "ActionMenuItem__icon" },
            React.createElement(Icon, { name: iconName, color: iconColor !== null && iconColor !== void 0 ? iconColor : 'currentColor' }))) : null,
        React.createElement("span", { className: "ActionMenuItem__content" }, children),
        cascading ? (React.createElement("span", { className: "ActionMenuItem__icon" },
            React.createElement(Icon, { name: "chevron_right" }))) : null));
});
//# sourceMappingURL=ActionMenuItem.js.map